import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateUserAccessTeam } from '../redux/slices/userAccessTeam';
import { wsSubscribe, wsUnsubscribe } from '../utils/wsManager';

const useUserTeamWebSocket = () => {
  const { userDetails } = useSelector((state) => state.userDetails);
  const dispatch = useDispatch();

  useEffect(() => {
    let wsKey = null;

    if (userDetails?.user?.id) {
      (async () => {
        const sub = await wsSubscribe(
          { entityType: 'UserTeams', entityId: -1 },
          { received: (event) => dispatch(updateUserAccessTeam(event?.data)) }
        );
        wsKey = sub?.key;
      })();
    }

    return () => {
      if (wsKey) wsUnsubscribe(wsKey);
    };
  }, [userDetails?.user?.id]);

  return {};
};

export default useUserTeamWebSocket;
